import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import OurProduct from "../pages/our-product/page";
import AboutUs from "../pages/about-us/page";
import OurServices from "../pages/our-services/page";
import Contact from "../pages/contact/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsOfService from "../pages/terms-of-service/page";
import RefundPolicy from "../pages/refund-policy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/our-product",
    element: <OurProduct />,
  },
  {
    path: "/about-us",
    element: <AboutUs />,
  },
  {
    path: "/our-services",
    element: <OurServices />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfService />,
  },
  {
    path: "/refund-policy",
    element: <RefundPolicy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;